import { createAction, props } from '@ngrx/store';
import { IErrors } from '../../models/error';
import {
  IAuthorizedResponse,
  ICreateSessionRequest,
  IDeleteAccountResponse,
  IGetUserRequestInfo,
  IGetUserResponse,
  IRefreshTokenRequestBody,
  IRefreshTokenResponse,
  IRemoveDevicesRequest,
  IRevokeSessionsRequest,
  ISendInvoiceRequest,
  ISendInvoiceResponse,
  ISessionResponse,
  ISessionTokenRequest,
  ISetting,
  IUpdateUserInfo,
  IUpdateUserInfoResponse,
  IUserBooksResponse,
  IUserBookWithChapterResponse,
  IUserChapterWithPagesResponse,
} from '../../models/user';
import {
  IFetchUserReportsRequest,
  IResponse,
  IUserReportPagedResult,
} from '../../models/admin';
import {
  ICancelAutoRenewingSubscription,
  ICancelOrderRequest,
  ICreateOrderRequest,
  IFulfillOrderRequest,
  IFulfillOrderResponse,
  IGetAllOrdersRequest,
  IOrderInfo,
  IOrderInfoPagedResult,
  ISaveOrderResponse,
  ISubscriptionPlanWithTaxAndDiscountInfo,
  IUpdateSubscriptionRequest,
} from '../../models/Subscription';

enum UserActions {
  // Authorize User
  AuthorizeUser = '[User] Authorize User',
  AuthorizeUserSuccess = '[Auth] Authorize User Success',
  AuthorizeUserFailure = '[Auth] Authorize User Failure',

  // Refresh Token
  RefreshToken = '[User] Refresh Token',
  RefreshTokenSuccess = '[User] Refresh Token Succes',
  RefreshTokenFailure = '[User] Refresh Token Failure',

  // Get User
  GetUser = '[User] Get User',
  GetUserSuccess = '[User] Get User Success',
  GetUserFailure = '[User] Get User Failure',

  // Update User
  UpdateUser = '[User] Update User',
  UpdateUserSuccess = '[User] Update User Success',
  UpdateUserFailure = '[User] Update User Failure',

  // Delete User Profile
  DeleteUserAccount = '[User] Delete User Account',
  DeleteUserAccountSuccess = '[User] Delete User Account Success',
  DeleteUserAccountFailure = '[User] Delete User Account Failure',

  // Check If User Exists or not with mobile/email
  CheckUserPhoneOrEmail = '[User] Check User Phone Or Email',
  CheckUserPhoneOrEmailSuccess = '[User] Check User Phone Or Email Success',
  CheckUserPhoneOrEmailFailure = '[User] Check User Phone Or Email Failure',

  // Delete user mobile number and update user
  DeleteMobileAndUpdateUser = '[User] Delete User Mobile Number And Update User Data',
  DeleteMobileAndUpdateUserSuccess = '[User] Delete User Mobile Number And Update User Data Success',
  DeleteMobileAndUpdateUserFailure = '[User] Delete User Mobile Number And Update User Data Failure',

  // Delete user mobile number
  DeleteUserMobile = '[User] Delete User Mobile Number',
  DeleteUserMobileSuccess = '[User] Delete User Mobile Number Success',
  DeleteUserMobileFailure = '[User] Delete User Mobile Number Failure',

  // Fetch User Books
  FetchUserBooks = '[User] Fetch User Books',
  FetchUserBooksSuccess = '[User] Fetch User Books Success',
  FetchUserBooksFailure = '[User] Fetch User Books Failure',

  // Fetch Book With Chapter
  FetchBookWithChapter = '[User] Fetch Book With Chapter',
  FetchBookWithChapterSuccess = '[User] Fetch Book With Chapter Success',
  FetchBookWithChapterFailure = '[User] Fetch Book With Chapter Failure',

  // Fetch Chapter With Pages
  FetchChapterWithPages = '[User] Fetch Chapter With Pages',
  FetchChapterWithPagesSuccess = '[User] Fetch Chapter With Pages Success',
  FetchChapterWithPagesFailure = '[User] Fetch Chapter With Pages Failure',

  // Clear Chapte With Pages
  ClearChapterWithPages = '[User] Clear Chapter With Pages State',

  // Clears User State
  ClearUserState = '[User] Clear User State',

  // Subscription Plan
  FetchSubscriptionPlans = '[User] Fetch Subscription Plans',
  FetchSubscriptionPlansSuccess = '[User] Fetch Subscription Plans Success',
  FetchSubscriptionPlansFailure = '[User] Fetch Subscription Plans Failure',

  // Create Order
  CreateOrder = '[User] Create Order',
  CreateOrderSuccess = '[User] Create Order Success',
  CreateOrderFailure = '[User] Create Order Failure',

  // Create Auto Renew Order
  // It reuses the CreateOrderSuccessAction/CreateorderFailureAction as IResponse<ISaveOrderResponse> is identical
  CreateAutoRenewOrder = '[User] Create Auto Renew Order',

  // Cancel Auto Renewing Subscription
  CancelAutoRenewingSubscription = '[User] Cancel Auto Renewing Subscription',
  CancelAutoRenewingSubscriptionSuccess = '[User] Cancel Auto Renewing Subscription Success',
  CancelAutoRenewingSubscriptionFailure = '[User] Cancel Auto Renewing Subscription Failure',

  // Update Order
  UpdateOrder = '[User] Update Order',
  UpdateOrderSuccess = '[User] Update Order Success',
  UpdateOrderFailure = '[User] Update Order Failure',

  // Fetch Orders
  FetchOrders = '[User] Get All Orders',
  FetchOrdersSuccess = '[User] Get All Orders Success',
  FetchOrdersFailure = '[User] Get All Orders Failure',

  // Clear Orders State
  ClearOrdersState = '[User] Clear Order State',

  // Get Order
  GetOrder = '[User] Get Order',
  GetOrderSuccess = '[User] Get Order Success',
  GetOrderFailure = '[User] Get Order Failure',

  // Cancel Order
  CancelOrder = '[User] Cancel Order',
  CancelOrderSuccess = '[User] Cancel Order Success',
  CancelOrderFailure = '[User] Cancel Order Failure',

  // Update Pagination State For Billing History Page
  BillingHistoryUpdatePagination = '[User] Billing History Update Pagingation',

  // Generate Payment Order
  GeneratePaymentOrder = '[User] Generate Payment Order',
  GeneratePaymentOrderSuccess = '[User] Generate Payment Order Success',
  GeneratePaymentOrderFailure = '[User] Generate Payment Order Failure',

  // Send Invoice
  SendInvoice = '[User] Send Invoice',
  SendInvoiceSuccess = '[User] Send Invoice Success',
  SendInvoiceFailure = '[User] Send Invoice Failure',

  // Get Chapter First Page
  GetChapterFirstPage = '[User] Get Chapter First Page',
  GetChapterFirstPageSuccess = '[User] Get Chapter First Page Success',

  // Remove Session Devices
  SessionRemoveDevices = '[User] Session Remove Devices',
  SessionRemoveDevicesSuccess = '[User] Session Remove Devices Success',
  SessionRemoveDevicesFailure = '[User] Session Remove Devices Failure',

  // Revoke Session
  SessionRevoke = '[User] Session Revoke',
  SessionRevokeSuccess = '[User] Session Revoke Success',
  SessionRevokeFailure = '[User] Session Revoke Failure',

  // Session Validate
  SessionValidate = '[User] Session Validate',
  SessionValidateSuccess = '[User] Session Validate Success',
  SessionValidateFailure = '[User] session Validate Failure',

  // Session Refresh
  SessionRefresh = '[User] Session Refresh',
  SessionRefreshSuccess = '[User] Session Refresh Success',
  SessionRefreshFailure = '[User] Session Refresh Failure',

  // Session Create
  SessionCreate = '[User] Session Create',
  SessionCreateSuccess = '[User] Session Create Success',
  SessionCreateFailure = '[User] Session Create Failure',

  // Logout Current Session
  SessionLogout = '[User] Session Logout',
  SessionLogoutSuccess = '[User] Session Logout Success',
  SessionLogoutFailure = '[User] Session Logout Failure',

  // FulFill Order
  FulfillOrder = '[User] Fulfill Order',
  FulfillOrderSuccess = '[User] Fulfill Order Success',
  FulfillOrderFailure = '[User] Fulfill Order Failure',

  // Update Subscription
  UpdateSubscription = '[User] Update Subscription',
  UpdateSubscriptionSuccess = '[User] Update Subscription Success',
  UpdateSubscriptionFailure = '[User] Update Subscription Failure',

  // Get Settings
  GetSetting = '[User] Get Settings',
  GetSettingSuccess = '[User] Get Settings Success',
  GetSettingFailure = '[User] Get Settings Failure',

  FetchUserReports = '[User] Fetch User Reports',
  FetchUserReportsSuccess = '[User] Fetch User Reports Success',
  FetchUserReportsFailure = '[User] Fetch User Reports Failure',
}

// Fetch Subscription Plans
export const FetchSubscriptionPlansAction = createAction(
  UserActions.FetchSubscriptionPlans,
);

export const FetchSubscriptionPlansSuccessAction = createAction(
  UserActions.FetchSubscriptionPlansSuccess,
  props<{ response: IResponse<ISubscriptionPlanWithTaxAndDiscountInfo[]> }>(),
);

export const FetchSubscriptionPlansFailureAction = createAction(
  UserActions.FetchSubscriptionPlansFailure,
  props<{ error: IErrors }>(),
);

// Authorize User
export const AuthorizeUserAction = createAction(UserActions.AuthorizeUser);
export const AuthorizeUserSuccessAction = createAction(
  UserActions.AuthorizeUserSuccess,
  props<{ response: IAuthorizedResponse }>(),
);
export const AuthorizeUserFailureAction = createAction(
  UserActions.AuthorizeUserFailure,
  props<{ error: IErrors }>(),
);

// Refresh Token
export const RefreshTokenAction = createAction(
  UserActions.RefreshToken,
  props<{ request: IRefreshTokenRequestBody }>(),
);
export const RefreshTokenSuccessAction = createAction(
  UserActions.RefreshTokenSuccess,
  props<{ response: IRefreshTokenResponse }>(),
);
export const RefreshTokenFailureAction = createAction(
  UserActions.RefreshTokenFailure,
  props<{ error: IErrors }>(),
);

// Get User
export const GetUserAction = createAction(
  UserActions.GetUser,
  props<{ request: IGetUserRequestInfo }>(),
);
export const GetUserSuccessAction = createAction(
  UserActions.GetUserSuccess,
  props<{ response: IGetUserResponse }>(),
);
export const GetUserFailureAction = createAction(
  UserActions.GetUserFailure,
  props<{ error: IErrors }>(),
);

// Update User
export const UpdateUserAction = createAction(
  UserActions.UpdateUser,
  props<{
    request: IUpdateUserInfo;
    userId: string;
    initiatedAfterMobileDelete?: boolean;
  }>(),
);
export const UpdateUserSuccessAction = createAction(
  UserActions.UpdateUserSuccess,
  props<{ response: IUpdateUserInfoResponse }>(),
);
export const UpdateUserFailureAction = createAction(
  UserActions.UpdateUserFailure,
  props<{ error: IErrors; initiatedAfterMobileDelete?: boolean }>(),
);

// Delete User
export const DeleteUserAccountAction = createAction(
  UserActions.DeleteUserAccount,
  props<{ userId: string }>(),
);
export const DeleteUserAccountSuccessAction = createAction(
  UserActions.DeleteUserAccountSuccess,
  props<{ response: IDeleteAccountResponse }>(),
);
export const DeleteUserAccountFailureAction = createAction(
  UserActions.DeleteUserAccountFailure,
  props<{ error: IErrors }>(),
);

// Check If user Exists Or Not With Mobile/Email
export const CheckUserPhoneOrEmailAction = createAction(
  UserActions.CheckUserPhoneOrEmail,
  props<{ mobileOrEmail: string; field: 'email' | 'mobile' }>(),
);
export const CheckUserPhoneOrEmailSuccessAction = createAction(
  UserActions.CheckUserPhoneOrEmailSuccess,
  props<{ response: IResponse<boolean>; field: 'email' | 'mobile' }>(),
);
export const CheckUserPhoneOrEmailFailureAction = createAction(
  UserActions.CheckUserPhoneOrEmailFailure,
  props<{ error: IErrors }>(),
);

// Delete user mobile number and update user
export const DeleteMobileAndUpdateUserAction = createAction(
  UserActions.DeleteMobileAndUpdateUser,
  props<{ request: IUpdateUserInfo; userId: string }>(),
);
export const DeleteMobileAndUpdateUserSuccessAction = createAction(
  UserActions.DeleteMobileAndUpdateUserSuccess,
  props<{ response: IResponse<boolean> }>(),
);
export const DeleteMobileAndUpdateUserFailureAction = createAction(
  UserActions.DeleteMobileAndUpdateUserFailure,
  props<{ error: IErrors }>(),
);

// Delete user mobile number
export const DeleteUserMobileAction = createAction(
  UserActions.DeleteUserMobile,
);
export const DeleteUserMobileSuccessAction = createAction(
  UserActions.DeleteUserMobileSuccess,
  props<{ response: IResponse<boolean> }>(),
);
export const DeleteUserMobileFailureAction = createAction(
  UserActions.DeleteUserMobileFailure,
  props<{ error: IErrors }>(),
);

// Fetch User Books
export const FetchUserBooksAction = createAction(
  UserActions.FetchUserBooks,
  props<{ pageNumber: number; pageSize: number }>(),
);
export const FetchUserBooksSuccessAction = createAction(
  UserActions.FetchUserBooksSuccess,
  props<{
    response: IUserBooksResponse;
    pageNumber: number;
    pageSize: number;
  }>(),
);
export const FetchUserBooksFailureAction = createAction(
  UserActions.FetchUserBooksFailure,
  props<{ error: IErrors }>(),
);

// Fetch Book With Chapter
export const FetchBookWithChapterAction = createAction(
  UserActions.FetchBookWithChapter,
  props<{ bookId: string; fromEffect?: boolean }>(),
);
export const FetchBookWithChapterSuccessAction = createAction(
  UserActions.FetchBookWithChapterSuccess,
  props<{ response: IUserBookWithChapterResponse }>(),
);
export const FetchBookWithChapterFailureAction = createAction(
  UserActions.FetchBookWithChapterFailure,
  props<{ error: IErrors }>(),
);

// Fetch Chapter With Pages
export const FetchChapterWithPagesAction = createAction(
  UserActions.FetchChapterWithPages,
  props<{
    chapterId: string;
    layoutType: 'Web' | 'Android' | 'Tablet';
    currentPageId?: string;
    count?: number;
    useTracking?: boolean;
    languageCode?: string | null;
  }>(),
);
export const FetchChapterWithPagesSuccessAction = createAction(
  UserActions.FetchChapterWithPagesSuccess,
  props<{ response: IUserChapterWithPagesResponse }>(),
);
export const FetchChapterWithPagesFailureAction = createAction(
  UserActions.FetchChapterWithPagesFailure,
  props<{ error: IErrors }>(),
);

// Clear Chapter With Pages Action
export const ClearChapterWithPagesStateAction = createAction(
  UserActions.ClearChapterWithPages,
);

// Create Order
export const CreateOrderAction = createAction(
  UserActions.CreateOrder,
  props<{ request: ICreateOrderRequest }>(),
);
export const CreateOrderSuccessAction = createAction(
  UserActions.CreateOrderSuccess,
  props<{ response: IResponse<ISaveOrderResponse> }>(),
);
export const CreateOrderFailureAction = createAction(
  UserActions.CreateOrderFailure,
  props<{ error: IErrors }>(),
);

// Create Auto Renew order
export const CreateAutoRenewOrderAction = createAction(
  UserActions.CreateAutoRenewOrder,
  props<{ request: ICreateOrderRequest; totalCycles?: number }>(),
);

// Cancel Auto Renewing Subscription
export const CancelAutoRenewingSubscriptionAction = createAction(
  UserActions.CancelAutoRenewingSubscription,
  props<{ request: ICancelAutoRenewingSubscription }>(),
);
export const CancelAutoRenewingSubscriptionSuccessAction = createAction(
  UserActions.CancelAutoRenewingSubscriptionSuccess,
  props<{ response: IResponse<boolean> }>(),
);
export const CancelAutoRenewingSubscriptionFailureAction = createAction(
  UserActions.CancelAutoRenewingSubscriptionFailure,
  props<{ error: IErrors }>(),
);

// Update Order
export const UpdateOrderAction = createAction(
  UserActions.UpdateOrder,
  props<{ request: Partial<IOrderInfo> & { OrderId: string } }>(),
);
export const UpdateOrderSuccessAction = createAction(
  UserActions.UpdateOrderSuccess,
  props<{ response: IResponse<ISaveOrderResponse> }>(),
);
export const UpdateOrderFailureAction = createAction(
  UserActions.UpdateOrderFailure,
  props<{ error: IErrors }>(),
);

// Fetch Orders
export const FetchOrdersAction = createAction(
  UserActions.FetchOrders,
  props<{ request: IGetAllOrdersRequest }>(),
);
export const FetchOrdersSuccessAction = createAction(
  UserActions.FetchOrdersSuccess,
  props<{
    response: IOrderInfoPagedResult;
    paymentStatus?: string;
    orderStatus?: string;
  }>(),
);
export const FetchOrdersFailureAction = createAction(
  UserActions.FetchOrdersFailure,
  props<{ error: IErrors }>(),
);

export const ClearOrdersStateAction = createAction(
  UserActions.ClearOrdersState,
);

// Get Order
export const GetOrderAction = createAction(
  UserActions.GetOrder,
  props<{ orderId: string }>(),
);
export const GetOrderSuccessAction = createAction(
  UserActions.GetOrderSuccess,
  props<{ response: IResponse<IOrderInfo> }>(),
);
export const GetOrderFailureAction = createAction(
  UserActions.GetOrderFailure,
  props<{ error: IErrors }>(),
);

// Cancel Order
export const CancelOrderAction = createAction(
  UserActions.CancelOrder,
  props<{ request: ICancelOrderRequest }>(),
);
export const CancelOrderSuccessAction = createAction(
  UserActions.CancelOrderSuccess,
  props<{ response: IResponse<boolean> }>(),
);
export const CancelOrderFailureAction = createAction(
  UserActions.CancelOrderFailure,
  props<{ error: IErrors }>(),
);

// Generate Payment Order
export const GeneratePaymentOrderAction = createAction(
  UserActions.GeneratePaymentOrder,
  props<{ orderId: string }>(),
);
export const GeneratePaymentOrderSuccessAction = createAction(
  UserActions.GeneratePaymentOrderSuccess,
  props<{ response: IResponse<ISaveOrderResponse> }>(),
);
export const GeneratePaymentOrderFailureAction = createAction(
  UserActions.GeneratePaymentOrderFailure,
  props<{ error: IErrors }>(),
);

export const BillingHistoryUpdatePaginationAction = createAction(
  UserActions.BillingHistoryUpdatePagination,
  props<{ pageNumber: number; pageSize: number }>(),
);

// Clear UserState
export const ClearUserStateAction = createAction(UserActions.ClearUserState);

// Send Invoice
export const SendInvoiceAction = createAction(
  UserActions.SendInvoice,
  props<{ request: ISendInvoiceRequest }>(),
);
export const SendInvoiceSuccessAction = createAction(
  UserActions.SendInvoiceSuccess,
  props<{ response: IResponse<ISendInvoiceResponse> }>(),
);
export const SendInvoiceFailureAction = createAction(
  UserActions.SendInvoiceFailure,
  props<{ error: IErrors }>(),
);

// Get Chapter First Page
export const GetChapterFirstPageAction = createAction(
  UserActions.GetChapterFirstPage,
  props<{ chapterId: string; languageCode?: string | null }>(),
);
export const GetChapterFirstPageSuccessAction = createAction(
  UserActions.GetChapterFirstPageSuccess,
  props<{ response: IUserChapterWithPagesResponse }>(),
);

// Session Remove Devices
export const SessionRemoveDevicesAction = createAction(
  UserActions.SessionRemoveDevices,
  props<{ request: IRemoveDevicesRequest }>(),
);
export const SessionRemoveDevicesSuccessAction = createAction(
  UserActions.SessionRemoveDevicesSuccess,
  props<{ response: IResponse<string> }>(),
);
export const SessionRemoveDevicesFailureAction = createAction(
  UserActions.SessionRemoveDevicesFailure,
  props<{ error: IErrors }>(),
);

// Session Revoke
export const SessionRevokeAction = createAction(
  UserActions.SessionRevoke,
  props<{ request: IRevokeSessionsRequest }>(),
);
export const SessionRevokeSuccessAction = createAction(
  UserActions.SessionRevokeSuccess,
  props<{ response: IResponse<string> }>(),
);
export const SessionRevokeFailureAction = createAction(
  UserActions.SessionRevokeFailure,
  props<{ error: IErrors }>(),
);

// Session Validate
export const SessionValidateAction = createAction(
  UserActions.SessionValidate,
  props<{ request: ISessionTokenRequest }>(),
);
export const SessionValidateSuccessAction = createAction(
  UserActions.SessionValidateSuccess,
  props<{ response: IResponse<boolean> }>(),
);
export const SessionValidateFailureAction = createAction(
  UserActions.SessionValidateFailure,
  props<{ error: IErrors }>(),
);

// Session Refresh
export const SessionRefreshAction = createAction(
  UserActions.SessionRefresh,
  props<{ request: ISessionTokenRequest }>(),
);
export const SessionRefreshSuccessAction = createAction(
  UserActions.SessionRefreshSuccess,
  props<{ response: IResponse<ISessionResponse> }>(),
);
export const SessionRefreshFailureAction = createAction(
  UserActions.SessionRefreshFailure,
  props<{ error: IErrors }>(),
);

// Session Create
export const SessionCreateAction = createAction(
  UserActions.SessionCreate,
  props<{ request: ICreateSessionRequest }>(),
);
export const SessionCreateSuccessAction = createAction(
  UserActions.SessionCreateSuccess,
  props<{ response: IResponse<ISessionResponse> }>(),
);
export const SessionCreateFailureAction = createAction(
  UserActions.SessionCreateFailure,
  props<{ error: IErrors }>(),
);

// Session Logout
export const SessionLogoutAction = createAction(UserActions.SessionLogout);
export const SessionLogoutSuccessAction = createAction(
  UserActions.SessionLogoutSuccess,
  props<{ response: IResponse<string> }>(),
);
export const SessionLogoutFailureAction = createAction(
  UserActions.SessionLogoutFailure,
  props<{ error: IErrors }>(),
);

// Fulfill Order
export const FulFillOrderAction = createAction(
  UserActions.FulfillOrder,
  props<{ request: IFulfillOrderRequest }>(),
);
export const FulfillOrderSuccessAction = createAction(
  UserActions.FulfillOrderSuccess,
  props<{ response: IResponse<IFulfillOrderResponse> }>(),
);
export const FulfillOrderFailureAction = createAction(
  UserActions.FulfillOrderFailure,
  props<{ error: IErrors }>(),
);

// Update Subscription
export const UpdateSubscriptionAction = createAction(
  UserActions.UpdateSubscription,
  props<{ subscriptionId: string; request: IUpdateSubscriptionRequest }>(),
);
export const UpdateSubscriptionSuccessAction = createAction(
  UserActions.UpdateSubscriptionSuccess,
  props<{ response: IResponse<boolean> }>(),
);
export const UpdateSubscriptionFailureAction = createAction(
  UserActions.UpdateSubscriptionFailure,
  props<{ error: IErrors }>(),
);

// Get Settings
export const GetSettingAction = createAction(UserActions.GetSetting);
export const GetSettingSuccessAction = createAction(
  UserActions.GetSettingSuccess,
  props<{ response: IResponse<ISetting[]> }>(),
);
export const GetSettingFailureAction = createAction(
  UserActions.GetSettingFailure,
  props<{ error: IErrors }>(),
);

// User Reports
export const FetchUserReportsAction = createAction(
  UserActions.FetchUserReports,
  props<{ request: IFetchUserReportsRequest }>(),
);
export const FetchUserReportsSuccessAction = createAction(
  UserActions.FetchUserReportsSuccess,
  props<{ response: IUserReportPagedResult }>(),
);
export const FetchUserReportsFailureAction = createAction(
  UserActions.FetchUserReportsFailure,
  props<{ error: IErrors }>(),
);
